<template>
    <div id="monitor">

    <NavbarElement :stopName="stopName" :timeSinceLastUpdate="timeSinceLastUpdate" :updateInProgress="updateInProgress" :kiosk="kiosk"></NavbarElement>

        <div class="container-fluid departures" v-if="!isNaN(this.stop.id)">
            <div class="row labels">
                <div class="col-2 line">Linie</div>
                <div class="col-6 destination">Ziel</div>
                <div class="col-3 time">Abfahrt</div>
                <div class="col-3 note"></div>
            </div>
            <hr>
                <DepartureElement v-for="departure in departures" :departure="departure" :key="departure.mode.diva.stateless+'.'+departure.mode.number+'.'+departure.id"></DepartureElement>
        </div>
    <SettingsElement v-else></SettingsElement>
</div>

</template>

<script>

import DepartureElement from './DepartureElement'
import NavbarElement from './NavbarElement.vue'
import SettingsElement from './SettingsElement.vue'

var rq = require('request-promise-native')
var _ = require('lodash')

export default {
  name: 'MonitorPage',
  props: {
    stop: Object,
    kiosk: Boolean
  },
  components: {
    DepartureElement,
    NavbarElement,
    SettingsElement
  },
  data: () => {
    return {
      departures: [],
      timers: {
        request: '',
        timeDisplay: '',
        reload: ''
      },
      lastUpdate: 0,
      timeSinceLastUpdate: '',
      stopName: '',
      updateInProgress: false,
      showError: false,
      query: '',
      searchStops: [],
      selectedStop: null

    }
  },
  created: function () {
    this.getDepartures()
    this.timers.request = setInterval(this.getDepartures, 60000)
    this.timers.timeDisplay = setInterval(this.updateTimeSinceLastUpdate, 1000)
    this.timers.reload = setInterval(this.reload, 36000000)
  },
  computed: {},
  methods: {
    reload: function () {
      window.location.reload(true)
    },
    getDepartures: function () {
      if (!isNaN(this.stop.id)) {
        this.updateInProgress = true
        let url = `https://www.bayern-fahrplan.de/jqm/beg_lite/XSLT_DM_REQUEST?convertStopsPTKernel2LocationServer=1&itOptionsActive=1&limit=12&locationServerActive=1&mode=direct&name_dm=${this.stop.id}&ptOptionsActive=1&stateless=1&type_dm=any&useAllStops=1&useRealtime=1&coordOutputFormat=MRCV&canChangeMOT=0&depType=stopEvents&includeCompleteStopSeq=1&mergeDep=1&nIPL=1&language=de&imparedOptionsActive=1&includedMeans=1&inclMOT_0=1&inclMOT_1=1&inclMOT_2=1&inclMOT_3=1&inclMOT_4=1&inclMOT_5=1&inclMOT_6=1&inclMOT_7=1&inclMOT_8=1&inclMOT_9=1&inclMOT_10=1&inclMOT_11=1&inclMOT_12=1&inclMOT_13=1&inclMOT_14=1&inclMOT_15=1&inclMOT_16=1&inclMOT_17=1`
        //let url = `https://www.bayern-fahrplan.de/jqm/beg_lite/XSLT_DM_REQUE?convertStopsPTKernel2LocationServer=1&itOptionsActive=1&limit=12&locationServerActive=1&mode=direct&name_dm=${this.stop.id}&type_dm=any&useAllStops=1&useRealtime=1&coordOutputFormat=MRCV&depType=stopEvents&includeCompleteStopSeq=1&mergeDep=1&language=de&imparedOptionsActive=1&includedMeans=1&inclMOT_0=1&inclMOT_1=1&inclMOT_2=1&inclMOT_3=1&inclMOT_4=1&inclMOT_5=1&inclMOT_6=1&inclMOT_7=1&inclMOT_8=1&inclMOT_9=1&inclMOT_10=1&inclMOT_11=1&inclMOT_12=1&inclMOT_13=1&inclMOT_14=1&inclMOT_15=1&inclMOT_16=1&inclMOT_17=1`
        let options = {
          method: 'GET',
          uri: url,
          timout: 10
        }

        rq(options)
          .then((body) => {
            let responseJSON = JSON.parse(body)

            this.departures = responseJSON.departures

            this.departures.forEach(function (element) {
              element.id = Math.floor(Math.random() * 100) // Adding a random id to each element for use with :key
              // This is important since key needs to be unique and
              // tripKey is only unique per line (and that's not for sure)
            })

            this.lastUpdate = Date.now()
            if (this.stopName === '') { this.stopName = responseJSON.departures[0].name }

            this.updateInProgress = false
          })
          .catch((error) => {
            this.updateInProgress = false
            console.error(error)
            // TODO: Catch Error
          })
      } else {
        this.updateInProgress = false
      }
    },
    cancelAutoUpdate: function () { clearInterval(this.timer) },
    updateTimeSinceLastUpdate: function () {
      let difference = Math.floor((Date.now() - this.lastUpdate) / 1000)

      if (difference < 90) {
        this.timeSinceLastUpdate = difference + 's'
      } else if (difference < 3600) {
        this.timeSinceLastUpdate = Math.floor(difference / 60) + ' Min.'
      }
    },
    async getStops (query) {
      let url = `https://www.bayern-fahrplan.de/autosuggest?anyObjFilter_sf=2&odvSortingMacro=beg&coordOutputFormat=WGS84%5BDD.DDDDD%5D&locationServerActive=1&outputFormat=JSON&type_sf=any&name_sf=${query}`
      const res = await fetch(url)
      const response = await res.json()

      if (Object.keys(response.stopFinder.points).length === 1 && Object.keys(response.stopFinder.points).length > 0) { this.searchStops = [response.stopFinder.points.point] } else { this.searchStops = response.stopFinder.points }

      this.searchStops.forEach(function (element, index) {
        element.suggest_name = element.name.replace(/,/g, '')
      })
    }

  },
  beforeDestroy () {
    clearInterval(this.timers.request)
    clearInterval(this.timers.timeDisplay)
    clearInterval(this.timers.reload)
  },
  watch: {
    query: _.debounce(function (q) { this.getStops(q) }, 500)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
pre {
    white-space: pre-wrap;       /* Since CSS 2.1 */
    white-space: -moz-pre-wrap;  /* Mozilla, since 1999 */
    white-space: -pre-wrap;      /* Opera 4-6 */
    white-space: -o-pre-wrap;    /* Opera 7 */
    word-wrap: break-word;       /* Internet Explorer 5.5+ */
}

.departures {
    background-color: #090833;
    color: #ffffff;
  font-size: 4.5rem;
  font-weight: 600;
}

.departures hr {
    margin: 1rem;
    background-color: #ffffff;
    border:none;
    height: .4rem;
}

.line {
    text-align: center;
}

.main {
    margin-top: 5em;
    display: flex;
    align-items: center;
    text-align: center;
}

</style>
